import { Factory } from 'miragejs';
import faker from 'faker';
import ENV from 'dashboard/config/environment';
import { getRandomInt } from '../utils';

export default Factory.extend({
  firstName() {
    return faker.name.firstName();
  },
  lastName() {
    return faker.name.lastName();
  },
  name() {
    return `${this.firstName} ${this.lastName}`;
  },
  email() {
    return faker.internet.exampleEmail(this.firstName, this.lastName);
  },
  avatarSmallUrl() {
    return ENV.APP.defaultAvatarUrl;
  },
  avatarMediumUrl() {
    return ENV.APP.defaultAvatarUrl;
  },
  lastUserAccess() {
    const days = getRandomInt(1, 50);
    return faker.date.recent(days).getTime();
  },
  linkedPurchaserName() {
    return `${faker.address.cityName()} ${
      Math.random() > 0.5 ? 'Elementary' : 'High'
    } School`;
  },
  pro() {
    return Math.random() > 0.5 ? true : false;
  },
  emailStatus() {
    const opts = ['PENDING', 'VERIFIED', 'UNVERIFIED'];
    return opts[getRandomInt(0, opts.length)];
  },
  accountStatus() {
    const opts = ['PENDING', 'SYNCED', 'MEMBER'];
    return opts[getRandomInt(0, opts.length)];
  },
  managed() {
    return Math.random() > 0.6 ? true : false;
  },
});
